/* 配置错误处理 */

/*
 例子:
 {
     errcode: 'NO LOGIN',                         //错误代码
     prompt: '你还没有登录或登录超时,请登录...',      //错误提示,空字符为不提示
     url: '/login'                               //跳转地址,true为刷新当前页,空字符串为不跳转
     fun: function () {                          //操作方法,空字符串为无

     }
 }
 */
let is_init = true;

export default {
    data: [
        {
            errcode: 'AUTHORIZATION_INVALID',
            prompt: '会话已过期,即将刷新页面',
            url: true,
            fun: function () {
                let that = this;

                /* 避免多次执行 */
                if(!is_init){
                    return false;
                }

                is_init = false;

                tools.cache.set('Authorization', '');
                tools.cache.set('isLogin', 0);
                tools.cache.set('isArtLogin', 0);
                tools.cache.set('isMediaLogin', 0);
                tools.cache.del('mediakname');
                tools.cache.del('nickname');
                tools.cache.del('artkname');

                //关闭所有加载中的弹窗
                tools.alert.closeAll('loading');

                //尝试关闭阴影
                $('[i="popupBg"]').removeClass('db');
            }
        },
        {
            errcode: 'NO LOGIN ARTIST',
            prompt: '你还没有登录或登录超时,请登录...',
            url: true,
            fun: function () {
                //更改本地登录状态
                window.tools.cache.del('isLogin');
                window.tools.cache.del('nickname');
            }
        },
        {
            errcode: 'NO LOGIN MEDIA',
            prompt: '你还没有登录或登录超时,请登录...',
            url: true,
            fun: function () {
                //更改本地登录状态
                window.tools.cache.del('isMediaLogin');
                window.tools.cache.del('mediakname');
            }
        },
        {
            errcode: 'NO LOGIN ART GALLERY',
            prompt: '你还没有登录或登录超时,请登录...',
            url:  true,
            fun: function () {
                //更改本地登录状态
                window.tools.cache.del('isArtLogin');
                window.tools.cache.del('artkname');
                var callback = tools.router.history.current.fullPath;
                tools.router.push('/login?type=2&callback=' + encodeURIComponent(callback) );
            }
        },
    ]

}



// WEBPACK FOOTER //
// ./src/error_handle.js